

export function Divider({style, color, thickness, marginY , marginX , width }) {

    return (
        <div className="divider" style={{ ...style, backgroundColor: color, height: thickness, marginTop: marginY, marginBottom: marginY, marginLeft: marginX, marginRight: marginX, width: width }} />
    )
}